import { Injectable } from '@angular/core';
import { ModuleService } from '../platform/nomenclatoare/module/module.service';
import { ModuleLocatiiActiveService } from '../platform/nomenclatoare/module-locatii-active/module-locatii-active.service';
import { finalize, forkJoin, ReplaySubject } from 'rxjs';
import { Generic, GenericLocatieActiva } from '../interfaces/generic.interface';

@Injectable({
    providedIn: 'root'
})
export class SidenavService {
    private modules: Generic[] = [];
    private locatiiActive: GenericLocatieActiva[] = [];

    private sidenavDataFetched$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

    constructor(
        private moduleService: ModuleService,
        private moduleLocatiiActiveService: ModuleLocatiiActiveService,
    ) { }

    loadLocatiiActive() {
        return this.moduleLocatiiActiveService.listModuleLocatiiActive();
    }

    loadModules() {
        return this.moduleService.listModule();
    }

    storeSidenavData() {
        return forkJoin({
            modules: this.loadModules(),
            locatiiActive: this.loadLocatiiActive(),
        }).subscribe({
            next: (result: { modules: Generic[]; locatiiActive: GenericLocatieActiva[] }) => {
                this.modules = result.modules;
                this.locatiiActive = result.locatiiActive;

                this.sidenavDataFetched$.next(true);
            },
            error: (err: any) => {
                console.log(err);
            },
        });
    }

    getModules() {
        return this.modules;
    }

    getLocatiiActive() {
        return this.locatiiActive;
    }

    isSidenavDataFetched$() {
        return this.sidenavDataFetched$;
    }
}
